module.exports = __webpack_public_path__ + "static/OP14-6ce9c6f743c04be8af450698b2c21167.png";